import { useEffect, useState } from 'react';

/**
 * Persist a boolean open/closed state to localStorage.
 * Defaults to false (closed) unless a saved value exists.
 */
export function usePersistentOpen(key: string, defaultOpen: boolean = false) {
	const readInitial = (): boolean => {
		try {
			const raw = window.localStorage.getItem(key);
			if (raw === null) return defaultOpen;
			return raw === 'true';
		} catch {
			return defaultOpen;
		}
	};

	const [isOpen, setIsOpen] = useState<boolean>(readInitial);

	useEffect(() => {
		try {
			window.localStorage.setItem(key, String(isOpen));
		} catch {
			// ignore storage failures (private mode, etc.)
		}
	}, [key, isOpen]);

	return [isOpen, setIsOpen] as const;
}

export default usePersistentOpen;
